module.exports = __webpack_public_path__ + "img/steam.8d587671.svg";